import { TextField, makeStyles } from '@material-ui/core';

const SEARCH_INPUT_ID = 'invitations-search';
const DELIVERY_DATE_FROM_INPUT_ID = 'invitations-delivery-date-from';
const DELIVERY_DATE_TO_INPUT_ID = 'invitations-delivery-date-to';

interface InvitationsListFiltersProps {
  search: string;
  deliveryDateFrom: string;
  deliveryDateTo: string;
  onSearchChange: (value: string) => void;
  onDeliveryDateFromChange: (value: string) => void;
  onDeliveryDateToChange: (value: string) => void;
}

const useStyles = makeStyles({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
});

export function InvitationsListFilters({
  search,
  deliveryDateFrom,
  deliveryDateTo,
  onSearchChange,
  onDeliveryDateFromChange,
  onDeliveryDateToChange,
}: InvitationsListFiltersProps) {
  const classes = useStyles();

  return (
    <section className={classes.filters}>
      <TextField
        id={SEARCH_INPUT_ID}
        size="small"
        label="Rechercher"
        placeholder="Éco-acteur"
        type="text"
        variant="outlined"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <TextField
        id={DELIVERY_DATE_FROM_INPUT_ID}
        size="small"
        label="Livraison du"
        type="date"
        variant="outlined"
        value={deliveryDateFrom}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: deliveryDateTo || undefined }}
        onChange={(event) => onDeliveryDateFromChange(event.target.value)}
      />
      <TextField
        id={DELIVERY_DATE_TO_INPUT_ID}
        size="small"
        label="au"
        type="date"
        variant="outlined"
        value={deliveryDateTo}
        InputLabelProps={{ shrink: true }}
        inputProps={{ min: deliveryDateFrom || undefined }}
        onChange={(event) => onDeliveryDateToChange(event.target.value)}
      />
    </section>
  );
}
